import { CategoriaProtocolo } from ".";

export class UsuarioCategoriaServico{

    responsavel : number;
    categoriaservicos: Array<CategoriaProtocolo>;
}